import { FC } from 'react'
import { StyledHomeBanner } from '.'

const HomeBanner: FC = () => {
  return (
    <StyledHomeBanner>
      <h1>Education to grow your business</h1>
      <p>
        Our self-paced digital courses help you get crystal clear on your strategy so you can
        uplevel your business.
      </p>
    </StyledHomeBanner>
  )
}

export default HomeBanner
